// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.extraction-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.extraction-container img {
  width: auto;
  height: 50px;
}

::ng-deep .myTooltip .mdc-tooltip__surface {
  background: #ecac54 !important;
  font-size: 1rem !important;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/extract-pdf-button/extract-pdf-button.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;AAAE;EACE,WAAA;EACA,YAAA;AAEJ;;AAEE;EACA,8BAAA;EACA,0BAAA;AACF;;AAEA;EACE,kCAAA;AACF","sourcesContent":[".extraction-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  img {\r\n    width: auto;\r\n    height: 50px;\r\n  }\r\n}\r\n::ng-deep .myTooltip {\r\n  .mdc-tooltip__surface {\r\n  background: #ecac54 !important;\r\n  font-size: 1rem !important;\r\n  }\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  background-color: white !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
